import axios from "axios";

import ApiConstants from "../constants/Api";
const { API_HOST } = ApiConstants;

const BrokerTickerAPI = {
  getQuickBuyTickers: () => axios.get(`${API_HOST}/api/v3/broker/tickers`),
};

export default BrokerTickerAPI;
